import { RelatedFilesQueryResponseType } from '@/common/queries/relatedFiles/relatedFilesQuery.type.ts';
import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';

export const showRelatedFilesDetailCardDataGenerator = (
  data: RelatedFilesQueryResponseType,
): DetailCardItemData[][] =>
  data.map(
    (file) =>
      [
        {
          type: 'default',
          keyName: 'شناسه پرونده',
          value: file.order_id,
          dirLtr: true,
        },
        {
          type: 'tel',
          keyName: 'بیمه گذار',
          value: file.applicant_user_full_name,
        },
        { type: 'default', keyName: 'آدرس بازدید', value: file.visit_location },
      ] as DetailCardItemData[],
  );
